import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-card-header-next',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-card-header-next',
        '[class.cmps-card-header-next--collapsable]': '_collapsable',
        '(click)': '_onClick()',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardHeaderComponent {
    /** @private */
    _collapsable: boolean;

    /** @internal */
    // eslint-disable-next-line accessor-pairs
    set collapsable(value: boolean) {
        this._collapsable = value;
        this._changeDetectorRef.markForCheck();
    }

    /** @internal */
    _collapsed: boolean;

    /** @internal */
    // eslint-disable-next-line accessor-pairs
    set collapsed(value: boolean) {
        this._collapsed = value;
        this._changeDetectorRef.markForCheck();
    }

    /** @internal */
    _onCollapseChange: () => void;

    constructor(private readonly _changeDetectorRef: ChangeDetectorRef) {}

    /** @private */
    _onClick(): void {
        if (!this._collapsable) {
            return;
        }
        this._onCollapseChange?.();
    }
}
